var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraMuted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.6364 5C16.1382 5 16.5455 5.392 16.5455 5.875V9.55001L21.2846 6.35625C21.49 6.21801 21.7736 6.26613 21.9182 6.46476C21.9709 6.53826 22 6.62575 22 6.715V17.285C22 17.5265 21.7963 17.7226 21.5454 17.7226C21.4518 17.7226 21.3609 17.6945 21.2846 17.6438L16.5455 14.45V18.125C16.5455 18.608 16.1382 19 15.6364 19H2.90909C2.40728 19 2 18.608 2 18.125V5.875C2 5.392 2.40728 5 2.90909 5H15.6364ZM14.7272 6.75H3.81818V17.2501H14.7272V6.75ZM20.1818 9.23588L16.5455 11.6859V12.3141L20.1818 14.7641V9.23588Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M21.5 2.5L2 21.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMuted);
export default __webpack_public_path__ + "static/media/camera-muted.abe86cdc142ed2af9fad4da962d8c19a.svg";
export { ForwardRef as ReactComponent };